"use client";

import { c as _c } from "react/compiler-runtime";
import { Section } from "@/components/section";
import { Text } from "@/components/ui/text";
import { LoadMore } from "@/components/common/load-more";
import { ReadMore } from "@/components/common/read-more";
import { RenderIf } from "@/components/common/render-if";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { usePopup } from "@/providers/popup-provider";
import { EligibilityCard } from "@/components/common/eligibility-card";
import { cn } from "@/lib/utils";
type CourseAgendaProps = {
  section: PageSections;
  data: {
    courseAgenda: {
      hasHtmlDescription?: boolean;
      description?: string;
      seoHeading?: string;
      heading?: string;
      list?: {
        seoHeading?: string;
        heading: string;
        description: string;
      }[];
      eligibilityCriteria: {
        hasHtmlDescription?: boolean;
        description: string;
        list?: {
          seoHeading?: string;
          heading: string;
          description: string;
        }[];
      };
    };
    seoHeading?: string;
    heading: string;
    buttonText: string;
    buttonUrl: string;
    serviceId: number;
    serviceName: string;
    hasGrouped: boolean;
  };
};
const CourseAgenda = t0 => {
  const $ = _c(41);
  const {
    data,
    section
  } = t0;
  const {
    courseAgenda
  } = data;
  const {
    openPopup
  } = usePopup();
  let t1;
  if ($[0] !== data.serviceId || $[1] !== openPopup) {
    t1 = () => {
      openPopup({
        type: "download-brochure",
        title: "Download Curriculum",
        data: {
          serviceId: data.serviceId
        }
      });
    };
    $[0] = data.serviceId;
    $[1] = openPopup;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDownloadBrochur = t1;
  const t2 = !data.hasGrouped;
  let t3;
  if ($[3] !== section.sectionClass || $[4] !== t2) {
    t3 = cn(section.sectionClass, {
      "dark:from-background bg-linear-to-b from-violet-50 to-white dark:to-transparent": t2
    });
    $[3] = section.sectionClass;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = data?.seoHeading;
  const t5 = data?.heading;
  const t6 = data?.buttonText;
  const t7 = data?.buttonUrl;
  const t8 = !Boolean(courseAgenda?.hasHtmlDescription);
  const t9 = courseAgenda?.heading;
  let t10;
  if ($[6] !== t9) {
    t10 = <AccordionTrigger>{t9}</AccordionTrigger>;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const t11 = courseAgenda?.description;
  let t12;
  if ($[8] !== t11) {
    t12 = <AccordionContent render={<Text>{t11}</Text>} />;
    $[8] = t11;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== t10 || $[11] !== t12) {
    t13 = <Accordion><AccordionItem>{t10}{t12}</AccordionItem></Accordion>;
    $[10] = t10;
    $[11] = t12;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Accordion defaultValue={["course-agenda-0"]} />;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== courseAgenda?.list) {
    t15 = courseAgenda?.list || [];
    $[14] = courseAgenda?.list;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t15) {
    t16 = <LoadMore wrapper={t14} items={t15} initialVisibleItems={4} renderItems={_temp} />;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t13 || $[19] !== t16 || $[20] !== t8) {
    t17 = <div className="col-span-12 sm:col-span-12"><RenderIf condition={t8} fallback={t13}>{t16}</RenderIf></div>;
    $[18] = t13;
    $[19] = t16;
    $[20] = t8;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const t18 = !!courseAgenda?.eligibilityCriteria?.hasHtmlDescription;
  const t19 = courseAgenda?.eligibilityCriteria?.description;
  const t20 = courseAgenda?.eligibilityCriteria?.list;
  let t21;
  if ($[22] !== data.serviceName || $[23] !== handleDownloadBrochur || $[24] !== t18 || $[25] !== t19 || $[26] !== t20) {
    t21 = <div id="request-for-group-training" className="col-span-12 scroll-mt-22 sm:col-span-12 sm:scroll-mt-31"><EligibilityCard courseName={data.serviceName} isHtmlDescription={t18} description={t19} list={t20} onAction={handleDownloadBrochur} /></div>;
    $[22] = data.serviceName;
    $[23] = handleDownloadBrochur;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== t17 || $[29] !== t21) {
    t22 = <div className="grid grid-cols-12 gap-5">{t17}{t21}</div>;
    $[28] = t17;
    $[29] = t21;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== handleDownloadBrochur || $[32] !== section.name || $[33] !== section.sectionId || $[34] !== t22 || $[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6 || $[39] !== t7) {
    t23 = <Section className={t3} id={section.sectionId} data-title={section.name} seoTitle={t4} title={t5} actionLabel={t6} path={t7} onAction={handleDownloadBrochur}>{t22}</Section>;
    $[31] = handleDownloadBrochur;
    $[32] = section.name;
    $[33] = section.sectionId;
    $[34] = t22;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  return t23;
};
export default CourseAgenda;
function _temp(item, index) {
  return <AccordionItem key={`course-agenda-${index}`} value={`course-agenda-${index}`}><AccordionTrigger>{item?.heading}</AccordionTrigger><AccordionContent render={index === 0 ? <ReadMore text={item?.description} minHeight="350px" className="typeset typeset-docs" /> : <Text className="typeset typeset-docs">{item?.description}</Text>} /></AccordionItem>;
}